export default __webpack_public_path__ + "static/media/task-management-circle.80d1d1df.png";